import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import QRDisplay from './components/QRDisplay';
import MessageLogs from './components/MessageLogs';
import SendMessage from './components/SendMessage';
import axios from 'axios';
import './App.css';

function App() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoutMessage, setLogoutMessage] = useState('');

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  const handleLogout = async () => {
    if (window.confirm('Apakah Anda yakin ingin logout dari WhatsApp? Ini akan menghapus semua data sesi dan Anda perlu scan QR code lagi.')) {
      setIsLoggingOut(true);
      setLogoutMessage('');
      
      try {
        const response = await axios.post(`${API_BASE_URL}/api/logout`);
        setLogoutMessage('✅ Berhasil logout dari WhatsApp. QR code baru akan dibuat.');
        
        // Refresh halaman setelah 3 detik
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        
      } catch (error) {
        console.error('Error during logout:', error);
        setLogoutMessage('❌ Gagal logout: ' + (error.response?.data?.error || error.message));
      } finally {
        setIsLoggingOut(false);
      }
    }
  };

  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <h1 className="nav-title">Sissae Whatsapp Manager</h1>
            <div className="nav-links">
              <Link to="/" className="nav-link">QR Code</Link>
              <Link to="/messages" className="nav-link">Message Logs</Link>
              <Link to="/send" className="nav-link">Send Message</Link>
              <button 
                onClick={handleLogout}
                disabled={isLoggingOut}
                className="logout-btn"
                title="Logout dari WhatsApp dan hapus semua data sesi"
              >
                {isLoggingOut ? 'Logging out...' : '🚪 Logout'}
              </button>
            </div>
          </div>
        </nav>

        {logoutMessage && (
          <div className={`logout-message ${logoutMessage.includes('✅') ? 'success' : 'error'}`}>
            {logoutMessage}
          </div>
        )}

        <main className="main-content">
          <Routes>
            <Route path="/" element={<QRDisplay />} />
            <Route path="/messages" element={<MessageLogs />} />
            <Route path="/send" element={<SendMessage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
